/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import { SwitchInput } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import styles from '../styles/formFieldToggleItem.module.scss';

const FormFieldToggleItem = ({
  title = '',
  toggleId,
  value = false,
  parentId = null,
  fieldValue = '',
  helperText = '',
  onHandleChange = () => {},
  isSubToggle = false,
}) => {
  const [toggleValue, setToggleValue] = useState(value);

  const onHandleSwitchChange = ({ id, val, field }) => {
    onHandleChange({ parentId: id, value: val, field });
    setToggleValue((previousValue) => !previousValue);
  };

  return (
    <div className={classnames(styles.element, { [styles.isSubToggle]: isSubToggle })}>
      <div className={styles.wrap}>
        <Typo
          className={styles.subTitle}
          variant={isSubToggle ? 'b01' : 'd02'}
          weight={isSubToggle ? 'medium' : ''}
        >
          {title}
        </Typo>
        <SwitchInput
          isChecked={toggleValue}
          onChange={() =>
            onHandleSwitchChange({ id: parentId, val: !toggleValue, field: fieldValue })
          }
          toggleId={toggleId}
          text={!toggleValue ? i18n.t('off') : i18n.t('on')}
        />
      </div>
      <div className={styles.helperTextWrap}>
        <Typo className={styles.helperText} color="secondary" variant="b01">
          {helperText}
        </Typo>
      </div>
      <div />
    </div>
  );
};

FormFieldToggleItem.propTypes = {
  title: PropTypes.string,
  value: PropTypes.bool,
  parentId: PropTypes.number,
  fieldValue: PropTypes.string,
  helperText: PropTypes.string,
  onHandleChange: PropTypes.func,
  isSubToggle: PropTypes.bool,
};

export default React.memo(FormFieldToggleItem);
